import { useState } from "react";
import { Button, Input, Modal, Form, Select, Checkbox, Space } from "antd";
import { useGetBrandsQuery } from "../../redux/services/brandApi";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";

const { Option } = Select;

const AddFormQuestionInFormSectionModal = (props: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { isModalOpen, formSection, onCancel, addFormQuestion, selectedFormQuestion, onUpdateFormQuestion, isEditMode } = props;

  const { data, error, isLoading } = useGetBrandsQuery({all_pages: true});
  const brands: any = data?.brands || [];

  const getQuestionBrandsAttributes = (values: any) => {
    let form_question_brands_attributes = null;
    if(isEditMode){
      form_question_brands_attributes = selectedFormQuestion.question_brands.map((question_brand: any) => {
        if(values.form_question_brands_attributes.includes(question_brand.brand.id)){
          return { id: question_brand.id, brand_id: question_brand.brand.id };
        } else {
          return { id: question_brand.id, _destroy: true };
        }
      })
      const brandIds = selectedFormQuestion.question_brands.map((question_brand: any) => question_brand.brand.id);
      const newBrandIds = values.form_question_brands_attributes.filter((n: any) => !brandIds.includes(n));
      newBrandIds.map((brandId: any) => {
        form_question_brands_attributes.push({ brand_id: brandId })
      })
    }
    else {
      form_question_brands_attributes = values
        .form_question_brands_attributes
        .map((brandId: any) => {
          return { brand_id: brandId } 
          }
        );
    }
    return form_question_brands_attributes;
  }

  form.setFieldValue("form_section_id", formSection?.id);

  const onFinish = (values: any) => {
    values.form_question_brands_attributes = getQuestionBrandsAttributes(values);
    values.choices = values.choices?.map((x: any) => x.choice) || []

    if (Object.keys(selectedFormQuestion).length === 0) {
      const params = { question: values };
      addFormQuestion(params, setLoading, form);
    } else {
      const params = { question: values };
      onUpdateFormQuestion(params, setLoading, form, selectedFormQuestion?.id);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const handleSelectAll = (value :any) => {
    if (value && value.length && value.includes("all")) {
      const all = brands.map((x: any) => x.id);
      form.setFieldsValue({
        form_question_brands_attributes: all,
      })
    }
  }

  return (
    <Modal
      title={isEditMode ? "Update Question" : "Add Question"}
      open={isModalOpen}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={false}
    >
      <Form
        name="form_question_form"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={
          isEditMode
            ? {
                ...selectedFormQuestion,
                choices: selectedFormQuestion?.choices?.map((x: any) => {
                  return { choice: x };
                }),
                form_question_brands_attributes: selectedFormQuestion?.question_brands?.map(
                  (x: any) => x.brand?.id
                )
              }
            : {}
        }
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item style={{ display: "none" }} name="form_section_id" label="Section Id">
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: "Please input title" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <Input />
        </Form.Item>

        <Form.Item label="Is Mandatory" name="mandatory" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item name="question_type" label="Question Type">
          <Select
            placeholder="Select Question Type"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="free_text">Free Text</Option>
            <Option value="single_choice">Single Choice</Option>
            <Option value="multi_choice">Multi Choice</Option>
            <Option value="boolean">Boolean</Option>
            <Option value="numeric">Numeric</Option>
          </Select>
        </Form.Item>

        <Form.List name="choices">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, i) => (
                <Space key={i}>
                  <Form.Item
                    style={{ marginTop: "18px" }}
                    {...field}
                    name={[field.name, "choice"]}
                    key={field.key}
                    rules={[{ required: true, message: "Please enter choice" }]}
                  >
                    <Input addonBefore={`Choice ${field.name + 1}`} />
                  </Form.Item>
                  {fields && (
                    <Button
                      style={{ color: "red", marginTop: "-10px" }}
                      onClick={() => {
                        remove(field.name);
                      }}
                      icon={<CloseOutlined />}
                    />
                  )}
                </Space>
              ))}
              {fields && fields.length < 20 && (
                <Form.Item>
                  <Button
                    type="dashed"
                    style={{ width: "216px" }}
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Choice
                  </Button>
                </Form.Item>
              )}
            </>
          )}
        </Form.List>

        <Form.Item
          label="Position"
          name="position"
          rules={[{ required: true, message: "Please input name" }]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item name="form_question_brands_attributes" label="Brands"
        rules={[{required: true, message: "Please select the brand"}]}>
          <Select
            mode="multiple"
            placeholder="Please select brands"
            maxTagCount={5}
            onChange={handleSelectAll}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option key="all" value="all">
              ---SELECT ALL---
            </Option>
            {brands?.map((brand: any) => (
              <Option key={brand.name} value={brand.id}>
                {brand.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="image_upload" label="Image Upload">
          <Select
            placeholder="Select Image Upload"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="no">No</Option>
            <Option value="optional">Optional</Option>
            <Option value="mandatory">Mandatory</Option>
          </Select>
        </Form.Item>

        <Form.Item name="video_upload" label="Video Upload">
          <Select
            placeholder="Select Video Upload"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="no">No</Option>
            <Option value="optional">Optional</Option>
            <Option value="mandatory">Mandatory</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Add to report" name="add_to_report" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item label="Add to customer report" name="add_to_customer_report" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select status" }]}
        >
          <Select
            placeholder="Select status"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
            <Option value="disabled">Disabled</Option>
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEditMode ? "Update" : "Add"}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddFormQuestionInFormSectionModal;
